import PropTypes from 'prop-types';
var agentType = {
  profilePhoto: PropTypes.string,
  name: PropTypes.string.isRequired,
  phone: PropTypes.string,
  profileUrl: PropTypes.string
};
export default agentType;